<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage organization</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!statusSucceed && organizationId" class="container">
            <div class="form-group">
                <label>Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of workspace">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label>Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of workspace"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <button v-show="statusInitial || statusInvalid" @click="handleUpdateOrganizationUnitCommandV1" type="button" class="btn btn-primary btn-lg">Save</button>
            <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Saving...</button>
        </div>

        <div v-else-if="statusSucceed" class="container">
            <h4>Congratulation! Organization was updated.</h4>
            <a class="btn btn-primary btn-lg" :href="`/#/admin/organizations/dashboard/${tid}`" role="button">Go to dashboard</a>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import VuePageQueries from "@Organizations/OrganizationUnits/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/OrganizationUnits/Domain/commands-vue-component";

    @Component({
        watch: {
            organizationUnitModel: 'organizationUnitModelChanged'
        }
    })
    export default class ManageOrganizationSsoPage extends mixins(PageBase, PageStatus, VuePageQueries, VuePageCommands) {
        name = '';
        description = '';

        get organizationUnitModel() { return this.model?.OrganizationUnit; }
        get organizationId() { return this.organizationUnitModel?.Id; }

        mounted() {
            this.setTitle('Manage organization');
            this.runOrganizationUnitQueryV1(this.tid);
        }

        //@Watch('organizationUnitModel')
        organizationUnitModelChanged(organizationUnitModel) {
            if (organizationUnitModel) {
                this.name = organizationUnitModel.Name;
                this.description = organizationUnitModel.Description;
            }
        }

        handleUpdateOrganizationUnitCommandV1() {
            this.setStatusInvoking();
            this.$clearValidationErrors();
            this.invokeUpdateOrganizationUnitCommandV1(this.organizationId, this.name, this.description);
        }

        succeedUpdateOrganizationUnitCommandV1() {
            this.setStatusSucceed();
        }

        invalidUpdateOrganizationUnitCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        failedUpdateOrganizationUnitCommandV1(status) {
            this.setStatusFailed();
        }
    }
</script>